export default {"src":"/_next/static/media/txt-svgrepo-com.ac9b7d7a.svg","height":303,"width":303,"blurWidth":0,"blurHeight":0};